<template>
  <div class="product__configurable" v-show="!checkSingleProduct">
    <div v-if="!this.$mobileDetect.mobile()" class="grid-x grid-padding-x">
      <div class="small-24 medium-14 large-12 cell">
        <div class="product__configurable-option" v-for="(option, index) in availableAttributes">
          <component :is="`catalog-product-configurable-select`" :option-data="option" :showStockNotifier="showStockNotifyAttribute" :step="index" :check-enabled="currentStep >= index"/>
        </div>
      </div>
    </div>
    <template v-else v-for="(option, index) in availableAttributes">
      <component :is="`catalog-product-configurable-select`" :option-data="option" :showStockNotifier="showStockNotifyAttribute" :step="index" :check-enabled="currentStep >= index"/>
    </template>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';
  import ServiceContainer from '@flashpointbv/solar-service-container';

  @Component(
    {
      name: 'catalog-product-configurable',
      components: {
        'catalog-product-configurable-select': ServiceContainer().getComponent('catalog-product-configurable-select')
      }
    }
  )

  export default class extends Vue {
    @Prop({default: false}) private readonly hideSingleOption: boolean;
    @Prop({default: false}) private readonly showPriceOption: boolean;
    @Prop({default: false}) private readonly showQtyOption: boolean;
    @Prop({default: false}) private readonly showStockNotifyAttribute: boolean;

    private get availableAttributes(): Array<object> {
      return this.$store.getters['CatalogConfigurableProduct/availableAttributes'];
    }

    private get checkSingleProduct(): Array<object> {
      return this.$store.getters['CatalogConfigurableProduct/checkSingleProduct'];
    }

    private get currentStep(): number {
      return this.$store.getters['CatalogConfigurableProduct/currentStep'];
    }
  }
</script>
